import AUTH from './auth.service';
import SETTINGS from './settings.service';
import USER from './user.service';

const SERVICES = {
	AUTH,
	SETTINGS,
	USER
};

export default SERVICES;
